import { SingleSelectGroupItems } from '@uhg-uicl/ui-core/dist/Molecules/SingleSelectGroup/types';
import { DocumentDirectory } from './types';

export const IRR_ISR_EOR = 'IRR-ISR-EOR';
export const IRR_OTHER = 'IRR-OTHER';
export const SUPPLEMENTAL_FILES = 'SUPPLEMENTAL-FILES';

export const getNavPaneForClients = (directories: DocumentDirectory[]) => {
  const navMenu: SingleSelectGroupItems[] = [];
  directories.forEach(function (value) {
    navMenu.push({
      text: value.name,
      items: getNavPaneForClientsSubDirectories(value.subDirectories),
    });
  });

  return {
    items: navMenu,
  };
};

export const getNavPaneForClientsSubDirectories = (subDirectories: DocumentDirectory[]) => {
  const items: any[] = [];
  subDirectories.forEach(function (value) {
    items.push({
      text: value.name,
      keyPath: value.keyPath,
    });
  });

  return items;
};
